/*
 *
 * ProjectDetailsPage constants
 *
 */
import { defineApiActionTypes } from 'utils/action-helper';

const prefix = 'ui/containers/ProjectDetailsPage';

export const UPDATE_NETWORK_STATUS = `${prefix}/UPDATE_NETWORK_STATUS`;

export const GET_PUSHER_CHANNELS = defineApiActionTypes(`${prefix}/GET_PUSHER_CHANNELS`);

export const UPDATE_PUSHER_MESSAGES = `${prefix}/UPDATE_PUSHER_MESSAGES`;

export const SET_CONVERSATION_REQUEST = defineApiActionTypes(`${prefix}/SET_CONVERSATION_REQUEST`);

export const GET_AGENT_DETAILS = defineApiActionTypes(`${prefix}/GET_AGENT_DETAILS`);

export const GET_SLACK_CHANNELS = defineApiActionTypes(`${prefix}/GET_SLACK_CHANNELS`);

export const UPDATE_USER_STATUS = defineApiActionTypes(`${prefix}/UPDATE_USER_STATUS`);

export const GET_USER_STATUS = defineApiActionTypes(`${prefix}/GET_USER_STATUS`);

export const LOGOUT_USER = defineApiActionTypes(`${prefix}/LOGOUT_USER`);
export const UPDATE_PROFILE_IMG = defineApiActionTypes(`${prefix}/UPDATE_PROFILE_IMG`);

export const GET_RECENT_GIFS = defineApiActionTypes(`${prefix}/GET_RECENT_GIFS`);
export const GET_TRENDING_GIFS = defineApiActionTypes(`${prefix}/GET_TRENDING_GIFS`);
export const GET_SEARCHED_GIFS = defineApiActionTypes(`${prefix}/GET_SEARCHED_GIFS`);

export const PUSHER_STATES = {
  connected: 'connected',
  connecting: 'connecting',
  unavailable: 'unavailable',
  offline: 'offline',
  online: 'online',
};

export const UPDATE_PROFILE_DATA = `${prefix}/UPDATE_PROFILE_DATA`;

export const GET_TIMEZONE_LIST = defineApiActionTypes(`${prefix}/GET_TIMEZONE_LIST`);

export const GIF = {
  INPUT_PLACEHOLDER: "Search GIF's",
  LIMIT: 10,
  RATING: 'pg',
  TRENDING_ENDPOINT: 'trending',
  SEARCH_ENDPOINT: 'search',
  TOOLTIP: 'GIF',
};
